/*
  OZ 2026-10-16: the store's search (Dereck: "a modal on PC and full-screen on mobile", products shown as on the rest
  of the store). Clicking the header search field, or the search icon on phones, opens the modal; Enter, "View all
  products" and the "+N more" tile go to the search page with the same category; Escape, the close button or the
  backdrop close it. Warehouse's own dropdown is never opened.

  Results (sections/oz-search-results.liquid), two requests side by side:
    products   the full search, /search?q=..&type=product[category]&section_id=oz-search-results: only products whose
               title holds every word typed, devices first, the first 10 as the store's cards, and the count;
    left       suggestions and collections from predictive search (All categories only), drawn when they arrive.
  Category (Dereck: one list of our own, not every product type): All categories, Phones, Tablets, Laptops, Watches,
  Accessories. Phones to Watches are Search & Discovery's product type filter; Accessories is the search template's
  "accessories" view, which leaves out the devices and services. The header's button and the modal's button show the
  same choice and either one changes it; it is kept for the session (sessionStorage, oz-search-cat).
*/
(function () {
  'use strict';
  var modal = null, input = null, results = null, timer = null, ctrls = [], last = '', lastFocus = null, drawn = null;

  /* ---------- category ---------- */
  var CATS = [
    { k: '', name: 'All categories', short: 'All', param: '' },
    { k: 'phones', name: 'Phones', short: 'Phones', param: '&filter.p.product_type=Phone' },
    { k: 'tablets', name: 'Tablets', short: 'Tablets', param: '&filter.p.product_type=Tablet' },
    { k: 'laptops', name: 'Laptops', short: 'Laptops', param: '&filter.p.product_type=Laptop' },
    { k: 'watches', name: 'Watches', short: 'Watches', param: '&filter.p.product_type=Smart%20Watch' },
    { k: 'accessories', name: 'Accessories', short: 'Accessories', param: '&view=accessories' }
  ];
  var KEY = 'oz-search-cat';
  function catOf(k) { for (var i = 0; i < CATS.length; i++) if (CATS[i].k === k) return CATS[i]; return CATS[0]; }
  var cat = (function () { try { return catOf(window.sessionStorage.getItem(KEY) || '').k; } catch (e) { return ''; } })();
  function paintCats() {
    var c = catOf(cat);
    document.querySelectorAll('[data-oz-scat]').forEach(function (b) {
      var full = b.querySelector('[data-oz-scat-label]');
      if (full && full.textContent !== c.name) full.textContent = c.name;
      var short = b.querySelector('[data-oz-scat-short]');
      if (short && short.textContent !== c.short) short.textContent = c.short;
      b.setAttribute('aria-label', 'Search category: ' + c.name);
      b.classList.toggle('is-set', !!c.k);
    });
  }
  function setCat(k) {
    cat = catOf(k).k;
    try { if (cat) window.sessionStorage.setItem(KEY, cat); else window.sessionStorage.removeItem(KEY); } catch (e) {}
    paintCats();
    if (modal && !modal.hidden) { last = ''; search(); }
  }
  function pageUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&type=product' + catOf(cat).param; }

  /* ---------- the category menu (the collection sort menu's look; no native list) ---------- */
  var menu = null; // { el, button, items, active }
  function closeMenu(refocus) {
    if (!menu) return;
    var m = menu;
    menu = null;
    m.el.remove();
    m.button.setAttribute('aria-expanded', 'false');
    m.button.classList.remove('is-open');
    if (refocus) m.button.focus({ preventScroll: true });
  }
  function activate(i) {
    if (!menu || i < 0 || i >= menu.items.length) return;
    menu.items.forEach(function (it, j) { it.classList.toggle('is-active', j === i); });
    menu.active = i;
    menu.el.setAttribute('aria-activedescendant', menu.items[i].id);
  }
  function choose(k) {
    if (!menu) return;
    var fromHeader = !(modal && modal.contains(menu.button));
    closeMenu(!fromHeader);
    setCat(k);
    if (fromHeader) {
      var field = document.querySelector('.header .search-bar__input');
      open(field ? field.value : '');
    } else if (input) {
      input.focus();
    }
  }
  function openMenu(button) {
    closeMenu(false);
    var el = document.createElement('div');
    el.className = 'oz-scat-menu';
    el.setAttribute('role', 'listbox');
    el.setAttribute('aria-label', 'Search category');
    el.tabIndex = -1;
    var items = [];
    var at = 0;
    CATS.forEach(function (c, i) {
      var it = document.createElement('div');
      it.className = 'oz-scat-menu__opt' + (c.k === cat ? ' is-on' : '');
      it.id = 'oz-scat-opt-' + i;
      it.setAttribute('role', 'option');
      it.setAttribute('aria-selected', c.k === cat ? 'true' : 'false');
      it.textContent = c.name;
      if (c.k === cat) at = i;
      it.addEventListener('click', function () { choose(c.k); });
      it.addEventListener('pointermove', function () { activate(i); });
      el.appendChild(it);
      items.push(it);
    });
    document.body.appendChild(el);
    var r = button.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var w = Math.max(r.width, 200);
    el.style.minWidth = w + 'px';
    var left = Math.min(r.left, vw - 12 - Math.max(w, el.offsetWidth));
    el.style.left = Math.max(12, left) + 'px';
    el.style.top = (r.bottom + 6) + 'px';
    menu = { el: el, button: button, items: items, active: -1 };
    button.setAttribute('aria-expanded', 'true');
    button.classList.add('is-open');
    activate(at);
    el.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-oz-scat]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (menu && menu.button === b) { closeMenu(true); return; }
    openMenu(b);
  }, true);
  document.addEventListener('pointerdown', function (e) {
    if (!menu) return;
    if (menu.el.contains(e.target) || menu.button.contains(e.target)) return;
    closeMenu(false);
  }, true);
  // window, capture: before the modal's Escape, so Escape closes the menu only
  window.addEventListener('keydown', function (e) {
    var k = e.key;
    if (!menu) {
      var b = e.target && e.target.closest && e.target.closest('[data-oz-scat]');
      if (b && (k === 'ArrowDown' || k === 'ArrowUp')) { e.preventDefault(); openMenu(b); }
      return;
    }
    var n = menu.items.length, handled = true;
    if (k === 'Escape' || k === 'Esc') closeMenu(true);
    else if (k === 'Tab') { closeMenu(true); handled = false; }
    else if (k === 'ArrowDown') activate(Math.min(n - 1, menu.active + 1));
    else if (k === 'ArrowUp') activate(Math.max(0, menu.active - 1));
    else if (k === 'Home') activate(0);
    else if (k === 'End') activate(n - 1);
    else if (k === 'Enter' || k === ' ') menu.items[menu.active].click();
    else if (k.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
      for (var j = 1; j <= n; j++) {
        var x = (menu.active + j) % n;
        if (menu.items[x].textContent.toLowerCase().indexOf(k.toLowerCase()) === 0) { activate(x); break; }
      }
    } else handled = false;
    if (handled) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  window.addEventListener('resize', function () { closeMenu(false); });
  document.addEventListener('scroll', function (e) { if (menu && !(e.target && e.target.nodeType === 1 && menu.el.contains(e.target))) closeMenu(false); }, true);

  /* ---------- the modal ---------- */
  var HINT = '<p class="oz-search__hint">Start typing a model, like &ldquo;iPhone 15&rdquo;.</p>';
  function build() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'oz-search';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Search');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="oz-search__backdrop" data-oz-search-close></div>' +
      '<div class="oz-search__panel">' +
        '<form class="oz-search__bar" action="/search" method="get" role="search">' +
          '<svg class="oz-search__icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 20l-4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '<input type="search" name="q" autocomplete="off" placeholder="Search phones, tablets, accessories" aria-label="Search">' +
          '<input type="hidden" name="type" value="product">' +
          '<button type="button" class="oz-scat__btn oz-scat__btn--modal" data-oz-scat aria-haspopup="listbox" aria-expanded="false" aria-label="Search category: All categories">' +
            '<span class="oz-scat__label" data-oz-scat-label>All categories</span><span class="oz-scat__short" data-oz-scat-short>All</span>' +
            '<svg class="oz-scat__chev" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M3 4.5l3 3 3-3"/></svg></button>' +
          '<button type="button" class="oz-search__x" data-oz-search-close aria-label="Close search">&times;</button>' +
        '</form>' +
        '<div class="oz-search__body" data-oz-search-results>' + HINT + '</div>' +
      '</div>';
    document.body.appendChild(modal);
    input = modal.querySelector('input[name="q"]');
    results = modal.querySelector('[data-oz-search-results]');
    input.addEventListener('input', function () {
      clearTimeout(timer);
      // the skeleton shows at the first key, not after the pause (Dereck 2026-10-17)
      var q = input.value.trim();
      if (q && q + '|' + cat !== last) skeleton();
      timer = setTimeout(search, 180);
    });
    modal.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (q && window.ozGa) window.ozGa('oz_search_select', { search_term: q, oz_target: 'submit' });
      if (q) window.location.href = pageUrl(q);
    });
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-oz-search-close]')) close();
      // GA4 (snippets/oz-ga.liquid): which result a search led to
      var a = e.target.closest('a[href]');
      if (a && results.contains(a) && window.ozGa) {
        var href = a.getAttribute('href') || '';
        window.ozGa('oz_search_select', {
          search_term: input.value.trim(),
          oz_target: a.closest('[data-oz-sr-all]') ? 'see_all' : /\/products\//.test(href) ? 'product' : /\/collections\//.test(href) ? 'collection' : /\/search/.test(href) ? 'suggestion' : 'other',
          oz_value: (a.innerText || '').replace(/\s+/g, ' ').trim(),
          link_url: href.split('?')[0]
        });
      }
    });
    paintCats();
  }

  function get(url) {
    var c = typeof AbortController !== 'undefined' ? new AbortController() : null;
    if (c) ctrls.push(c);
    return fetch(url, { credentials: 'same-origin', signal: c ? c.signal : undefined }).then(function (r) { return r.ok ? r.text() : ''; });
  }
  function part(html, sel) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.querySelector(sel);
  }
  // Grey cards in the answer's layout while a search runs (assets/oz-search.css, "Loading skeleton"); 8 cards, the CSS
  // keeps one row's worth on phones and tablets.
  var SKEL = (function () {
    var card = '<div class="oz-sk-card"><i class="oz-sk oz-sk-card__img"></i><i class="oz-sk oz-sk-card__t"></i><i class="oz-sk oz-sk-card__t2"></i><i class="oz-sk oz-sk-card__p"></i></div>';
    var line = '<i class="oz-sk oz-sk--line"></i>';
    return '<div class="oz-sr oz-sr--skel" aria-hidden="true">' +
      '<div class="oz-sr__side"><i class="oz-sk oz-sk--h"></i>' + line + line + line + line + '</div>' +
      '<div class="oz-sr__main"><div class="oz-sr__top"><i class="oz-sk oz-sk--h"></i></div><div class="oz-sk-grid">' +
      card + card + card + card + card + card + card + card + '</div></div></div>';
  })();
  function skeleton() {
    if (results.querySelector('.oz-sr--skel')) return;
    results.innerHTML = SKEL;
  }
  function search() {
    var q = input.value.trim();
    var key = q + '|' + cat;
    if (key === last) {
      // typed and deleted back to the query on screen: put its answer back over the skeleton
      if (drawn && results.querySelector('.oz-sr--skel')) { results.innerHTML = ''; results.appendChild(drawn); }
      return;
    }
    last = key;
    ctrls.forEach(function (c) { c.abort(); });
    ctrls = [];
    if (!q) { drawn = null; results.innerHTML = HINT; return; }
    skeleton();
    modal.classList.add('is-loading');
    var mainP = get(pageUrl(q) + '&section_id=oz-search-results');
    var sideP = cat ? Promise.resolve('') : get('/search/suggest?q=' + encodeURIComponent(q) + '&section_id=oz-search-results' +
      '&resources[type]=collection,query&resources[limit]=6&resources[limit_scope]=each');
    var side = null, sideDone = false;
    sideP.then(function (html) { side = html ? part(html, '[data-oz-sr-side]') : null; sideDone = true; }, function () { sideDone = true; });
    mainP.then(function (html) {
      if (key !== last) return;
      var main = part(html, '[data-oz-sr-main]');
      // the left column usually arrives first; wait for it a moment so the layout is drawn once
      var waited = 0;
      (function draw() {
        if (key !== last) return;
        if (!sideDone && waited < 250) { waited += 50; setTimeout(draw, 50); return; }
        var box = document.createElement('div');
        box.className = 'oz-sr';
        box.setAttribute('data-oz-sr', '');
        if (side) box.appendChild(side);
        if (main) box.appendChild(main);
        results.innerHTML = '';
        results.appendChild(box);
        drawn = box;
        modal.classList.remove('is-loading');
        fitGrid(q);
        if (window.lazySizes && window.lazySizes.loader) {
          results.querySelectorAll('.lazyload').forEach(function (img) { window.lazySizes.loader.unveil(img); });
        }
        if (!sideDone) {
          sideP.then(function () {
            if (key !== last || !side) return;
            box.insertBefore(side, box.firstChild);
            fitGrid(q);
          });
        }
      })();
    }).catch(function (e) { if (!e || e.name !== 'AbortError') modal.classList.remove('is-loading'); });
  }

  // Full rows only (Dereck 2026-10-16: it drew 10 then shrank): when the count is more than the cards drawn, the grid
  // keeps whole rows minus one cell and that cell is a "+N more" tile to the search page; the count comes in the same
  // answer (data-oz-sr-count), so the grid is laid out once.
  function fitGrid(q) {
    var main = results.querySelector('[data-oz-sr-main]');
    var grid = results.querySelector('.oz-sr__grid');
    var all = results.querySelector('[data-oz-sr-all]');
    if (all) all.href = pageUrl(q);
    if (!grid || !main) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .product-item:not(.oz-sr__more)'));
    var old = grid.querySelector('.oz-sr__more');
    if (old) old.remove();
    items.forEach(function (it) { it.hidden = false; });
    var total = Number(main.getAttribute('data-oz-sr-count')) || 0;
    var plus = main.hasAttribute('data-oz-sr-plus') ? '+' : '';
    if (!items.length || total <= items.length) return;
    var top = items[0].offsetTop, cols = 0;
    for (var i = 0; i < items.length && items[i].offsetTop === top; i++) cols++;
    var keep = Math.max(cols - 1, Math.floor((items.length + 1) / cols) * cols - 1);
    if (keep > items.length) keep = items.length;
    items.forEach(function (it, idx) { it.hidden = idx >= keep; });
    var rest = total - keep;
    var a = document.createElement('a');
    a.className = items[0].className.replace(/product-item--[^\s]+/g, '') + ' oz-sr__more';
    a.href = pageUrl(q);
    a.innerHTML = '<span class="oz-sr__more-n">' + (plus ? rest.toLocaleString('en-AU') + '+' : '+' + rest.toLocaleString('en-AU')) + '</span><span class="oz-sr__more-t">' +
      (rest === 1 ? 'more product' : 'more products') + '</span><span class="oz-sr__more-go">View all</span>';
    grid.appendChild(a);
  }
  var rt = null;
  window.addEventListener('resize', function () {
    if (!modal || modal.hidden) return;
    clearTimeout(rt);
    rt = setTimeout(function () { fitGrid(input.value.trim()); }, 150);
  });

  function open(value) {
    build();
    paintCats();
    if (modal.hidden && window.ozGa) window.ozGa('oz_search_open', {});
    lastFocus = document.activeElement;
    modal.hidden = false;
    // the locked page loses its scrollbar: pad by its width so nothing behind the modal moves sideways (as assets/oz-pdp-info.js)
    var bar = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.classList.add('oz-search-lock');
    if (bar > 0) document.body.style.paddingRight = bar + 'px';
    if (typeof value === 'string' && value) input.value = value;
    // focus inside the tap itself: iOS only raises the keyboard for a focus made during the user's gesture, never from a timer
    input.focus();
    input.select();
    if (input.value.trim()) { last = ''; search(); }
  }

  function close() {
    if (!modal || modal.hidden) return;
    closeMenu(false);
    modal.hidden = true;
    document.documentElement.classList.remove('oz-search-lock');
    document.body.style.paddingRight = '';
    if (lastFocus && lastFocus.blur) lastFocus.blur();
  }

  // the header field (and its wrapper) opens the modal instead of Warehouse's dropdown
  document.addEventListener('focusin', function (e) {
    var field = e.target.closest && e.target.closest('.header .search-bar__input, .header__search-bar-wrapper input[name="q"]');
    if (!field || (modal && modal.contains(field))) return;
    // no blur first: moving focus straight to the modal's field keeps the phone keyboard up
    open(field.value);
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-action="toggle-search"], .header__action-item--search a, .header__search-bar-wrapper .search-bar__submit');
    if (!t || (modal && modal.contains(t))) return;
    e.preventDefault();
    e.stopPropagation();
    var field = document.querySelector('.header .search-bar__input');
    open(field ? field.value : '');
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) close();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintCats); else paintCats();
})();
